export const endpoints = {
  auth: {
    loginRedirect: 'auth/microsoft/redirect?surface=onboarding',
    exchangeCode: 'auth/exchange-code',
    refresh: 'auth/refresh',
    logout: 'auth/logout',
  },
  onboarding: {
    me: 'onboarding/me',
    session: 'onboarding/session',
    get: 'onboarding',
    update: 'onboarding',
    adminConsentRedirect: 'onboarding/admin-consent-redirect',
    complete: 'onboarding/complete',
    config: 'onboarding/config',
    savePlan: 'onboarding/plan',
    saveLicences: 'onboarding/licences',
  },
  plans: {
    list: 'onboarding/plans',
  },
  stripe: {
    initiateCheckout: 'onboarding/stripe/checkout',
    verifyCheckout: 'onboarding/stripe/verify',
    checkoutPreview: 'onboarding/stripe/checkout-preview',
  },
};
